import React, {useContext} from 'react'
import EditLayoutSetting from "../actions/EditLayoutSetting"
import {message, Popconfirm} from "antd"
import parseToken from "../../../../helpers/parseToken"
import {deleteLayoutConfig} from "../../../../services/api/apiSetting"
import {SettingLayoutContext} from "../../context/SettingLayoutContext"

const LayoutTableItem = props => {
    const {item} = props
    const SettingLayoutPageContext = useContext(SettingLayoutContext)
    const {getListLayout} = SettingLayoutPageContext

    const _onDelete = async (id) => {
        try {
            const decodeToken = parseToken()
            const payload = {
                ids: [id]
            }
            const response = await deleteLayoutConfig(payload, decodeToken.sub)
            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            message.success('Xóa setting thành công')
            getListLayout()
        } catch (e) {
            message.error(e.message)
        }
    }

    return (
        <tr className="RowItem SettingItem">
            <td className="leadName">{item.tenantName}</td>
            <td className="leadName">{item.layoutType}</td>
            <td className="layoutBlock">{item.layoutBlock}</td>
            <td className="leadName">{item.layoutField}</td>
            <td className="fieldTitle">{item.fieldTitle}</td>
            <td className="leadName">{item.fieldType}</td>
            <td className="leadName">{item.fieldRequired === 1 ? "Bắt buộc" : "Không bắt buộc"}</td>
            <td className="leadName">{item.fieldDefaultValue}</td>
            <td className="leadName">{item.fieldOrder}</td>
            <td className="Actions text-center">
                <EditLayoutSetting currentItem={item}/>
                <Popconfirm placement="topLeft" title="Bạn chắc chắn muốn xóa setting layout này?"
                            onConfirm={() => _onDelete(item.id)} okText="Có" cancelText="Không">
                    <span className="material-icons cursor-pointer text-danger ml-2">delete</span>
                </Popconfirm>
            </td>
        </tr>
    )
}

LayoutTableItem.propTypes = {}

export default LayoutTableItem
